<template>
	<div class="exchange">
		<div class="exchange-body" v-if="!isSuccess">
			<div class="exchange-title"></div>
			<div class="exchange-input">
				<input v-model="code" type="text" placeholder="请输入兑换码" />
			</div>
			<div class="exchange-btns">
				<div class="exchange-btn cancel-btn" @click="onBackClick">
					取消
				</div>
				<div class="exchange-btn sure-btn" @click="onExchangeClick">
					确定
				</div>
			</div>
			<div class="rule-line"></div>
			<div class="rule-wrap">
				<div class="rule-title">兑换规则</div>
				<div class="rule-content">
					<p>
						1·兑换码可通过参与节点小宝或合作商家举行的运营活动获得;
					</p>
					<p>2·若兑换码无法兑换，需联系发放兑换码的平台核实;</p>
					<p>3·兑换账户默认为本机帐号，兑换成功后权益不可转移:</p>
					<p>4·兑换成功后，可至对应页面查看权益；</p>
					<p>5·所兑换的权益，以实际获得的兑换码为准。</p>
				</div>
			</div>
		</div>
		<div class="exchange-body success-body" v-else>
			<div class="exchange-success"></div>
			<!-- <div class="exchange-success-title">兑换成功</div> -->
			<div class="exchange-content">
				<div class="exchange-content-wrap">
					<div class="content-name">兑换成功</div>
					<div class="content-time">小宝会员卡{{ months }}个月</div>
				</div>
			</div>
			<div class="exchange-btns">
				<div class="exchange-btn sure-btn" @click="onBackClick">
					确定
				</div>
			</div>
			<div class="rule-line"></div>
			<div class="rule-wrap">
				<div class="rule-title">兑换规则</div>
				<div class="rule-content">
					<p>
						1·兑换码可通过参与节点小宝或合作商家举行的运营活动获得;
					</p>
					<p>2·若兑换码无法兑换，需联系发放兑换码的平台核实;</p>
					<p>3·兑换账户默认为本机帐号，兑换成功后权益不可转移:</p>
					<p>4·兑换成功后，可至对应页面查看权益；</p>
					<p>5·所兑换的权益，以实际获得的兑换码为准。</p>
				</div>
			</div>
		</div>
		<Tip v-if="tip" :tip="tip"></Tip>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import Tip from "@/components/Tip.vue";
export default {
	components: { Tip },
	data: function () {
		return {
			code: "",
			tip: "",
			months: 1,
			isSuccess: false,
		};
	},
	watch: {
		tip: function (newVal) {
			let _that = this;
			if (newVal) {
				setTimeout(function () {
					_that.tip = "";
				}, 3000);
			}
		},
	},
	methods: {
		...mapActions(["getExchange", "vipLeft"]),
		onBackClick: function () {
			this.$emit("onCloseClick");
		},
		onExchangeClick: function () {
			let _that = this;
			if (!_that.code) {
				_that.tip = "请输入兑换码";
				return;
			}
			_that.getExchange([
				_that.code,
				function (err, data) {
					if (!err && data.rtn == 0) {
						_that.isSuccess = true;
						_that.months = data.data.months ? data.data.months : 1;
						_that.vipLeft([]);
					} else {
						_that.tip = "兑换码无效";
					}
				},
			]);
		},
	},
};
</script>

<style lang="less" scoped>
.exchange {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(0, 0, 0, 0.2);
	z-index: 9;
	.exchange-body.success-body {
		height: 430px;
		margin-top: -215px;
	}
	.exchange-body {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 380px;
		height: 386px;
		margin-left: -190px;
		margin-top: -193px;
		background-color: #ffffff;
		background-size: 100% 100%;
		padding-top: 1px;
		background-image: linear-gradient(180deg, #fffbf5 0%, #ffffff 23.45%);
		box-shadow: 0px 4px 12px rgba(155, 146, 123, 0.26);
		border-radius: 12px;

		.exchange-title {
			width: 168px;
			height: 28px;
			background-image: url(../../assets/components/pay/exchange/title.png);
			background-size: 100% 100%;
			margin: 0 auto;
			margin-top: 25px;
		}
		.exchange-success {
			width: 237px;
			height: 87px;
			background-image: url(../../assets/components/pay/exchange/success-bg.png);
			background-size: 100% 100%;
			margin: 0 auto;
			margin-top: 15px;
			margin-bottom: 5px;
		}
		.exchange-content {
			width: 256px;
			height: 76px;
			background: linear-gradient(
				90.22deg,
				#fab425 0.18%,
				#fbd969 36.5%,
				#f76d23 99.81%
			);
			border-radius: 6px;
			padding-top: 1px;
			margin: 0 auto;
			margin-bottom: 0px;
			.exchange-content-wrap {
				width: 244px;
				height: 64px;
				margin: 0 auto;
				margin-top: 6px;
				background: linear-gradient(
					90.31deg,
					#fff4e4 4.18%,
					#fff4e4 99.73%
				);
				border-radius: 3px;
				padding-top: 1px;
				text-align: center;
				.content-name {
					font-weight: 600;
					font-size: 14px;
					line-height: 19px;
					color: #59340c;
					// margin-left: 18px;
					margin-top: 12px;
				}
				.content-time {
					font-weight: 400;
					font-size: 12px;
					line-height: 15px;
					color: #b07f50;
					// margin-left: 18px;
					margin-top: 6px;
				}
			}
		}
		.exchange-success-title {
			color: #f68712;
			font-size: 20px;
			line-height: 28px;
			height: 28px;
			text-align: center;
			margin-bottom: -20px;
		}
		.exchange-input {
			width: 268px;
			height: 48px;
			background: #fffcf5;
			border: 1px solid #f0f0e0;
			border-radius: 48px;
			margin: 0 auto;
			margin-top: 25px;
			overflow: hidden;
			border-radius: 48px;
			input {
				background-color: transparent;
				height: 48px;
				width: 100%;
				font-size: 18px;
				text-align: center;
				color: #666666;
			}
		}
		.exchange-btns {
			margin: 0 auto;
			text-align: center;
			margin-top: 15px;
			.exchange-btn {
				width: 128px;
				height: 42px;
				line-height: 42px;
				margin: 0 6px;
				border-radius: 120px;
				text-align: center;
				display: inline-block;
				vertical-align: top;
			}
			.exchange-btn:hover {
				cursor: pointer;
				opacity: 0.8;
			}
			.cancel-btn {
				background: rgba(246, 125, 14, 0.22);
				font-weight: 400;
				font-size: 16px;
				color: #a9572a;
			}
			.sure-btn {
				background: #f67d0e;
				font-weight: 400;
				font-size: 16px;
				color: #ffffff;
			}
		}

		.rule-line {
			width: 332px;
			height: 1px;
			border-bottom: 1px dashed #eaeaeb;
			margin: 0 auto;
			margin-top: 24px;
		}
		.rule-wrap {
			margin-left: 24px;
			margin-top: 24px;
			.rule-title {
				font-weight: 400;
				font-size: 16px;
				line-height: 20px;
				color: #666666;
			}
			.rule-content {
				margin-top: 6px;
				p {
					font-weight: 400;
					font-size: 12px;
					line-height: 20px;
					color: #999999;
				}
			}
		}
	}
}
</style>